import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { Group, useAssignContentsGroupsMutation, useGetGroupListQuery } from '../../../generated/graphql';
import { FormMultiSelect, FormCheckbox } from '../../form';
import styles from './AddContentsGroupsDialog.module.css';

type AddContentsGroupsDialogProps = {
    onClose: () => void,
    libraryId: string,
    ids: string[],
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const AddContentsGroupsDialog = (props: AddContentsGroupsDialogProps) => {
    const { libraryId, ids, style, visible, onClose } = props;
    const [assignContentsGroups, assignContentsGroupsResult] = useAssignContentsGroupsMutation();
    const [selectedGroups, setSelectedGroups] = useState<Group[]>([]);
    const [overwrite, setOverwrite] = useState(false);
    const [validationError, setValidationError] = useState('');
    const groups = useGetGroupListQuery({
        fetchPolicy: "no-cache",
        variables: { contains: "" }
    });

    const handleSubmit = () => {
        if (selectedGroups.length === 0) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        const groupIds = selectedGroups.map(t => t.id || "");
        assignContentsGroups({
            variables: { libraryId, ids, groupIds, overwrite }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Assign Content Group"
            type="OkCancel"
            isLoading={assignContentsGroupsResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.AddContentsGroupsDialog}
            style={style}
            data-testid="AddContentsGroupsDialog">
            <FormMultiSelect
                label="Groups"
                name="groups"
                value={selectedGroups}
                onChange={(v) => setSelectedGroups(v as Group[])}
                options={groups.data?.GroupList?.nodes || []}
                textField="name"
            />
            <FormCheckbox
                label="Overwrite"
                name="overwrite"
                checked={overwrite}
                onChange={setOverwrite}
            />
        </DialogBase>
    );
};

export default AddContentsGroupsDialog;